import {DefaultContainer} from "@shared/DefaultContainer.tsx";
import {DefaultPageProps} from "@models/DefaultProps.ts";
import {useSearchParams} from "react-router";
import {useState} from "react";
import {IEmpresa} from "@models/empresa/IEmpresa.ts";
import {useEmpresa} from "@components/empresas/hooks/useEmpresa.ts";
import {EmpresaInfoGrid} from "@components/empresas/info/EmpresaInfoGrid.tsx";

interface EmpresaPageProps extends Omit<DefaultPageProps, 'filtersProps' | 'pageProps'> {
}

export function EmpresaPage(props: EmpresaPageProps) {
    const {getEmpresa} = useEmpresa()
    const [searchParams] = useSearchParams()
    const [empresa, setEmpresa] = useState<IEmpresa>(props.preset)

    const id = searchParams.get('empresaId')

    if (empresa == null && id) {
        getEmpresa({id: Number(id)}).then(x => {
            if (x.items != null) {
                setEmpresa(x.items)
            }
        })
    }

    return (<DefaultContainer titulo={`Detalhes da empresa ${id}`} {...props}>
        <EmpresaInfoGrid value={empresa} expectedId={id ? Number(id) : undefined}/>
    </DefaultContainer>)
}